import { getState } from '~src/state';
import { displayImageManager } from '~src/sidebar/index';

export const removeTagFromCache = (imageItemId, tagId) => {
  const currentTag = getState('sidebarCurrentImagesTag', 'NO_TAG');
  const imageItem = window.editorConfig.sidebarImages[currentTag].items.find(
    (item) => item.objectId === imageItemId
  );

  imageItem.tags = imageItem.tags.filter((tag) => tag.objectId !== tagId);

  displayImageManager(imageItemId);
};
